import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useFormState } from 'react-final-form';
import { IAddressFieldProps } from '../Fields/Address/interfaces/address.interface';
import AvailableSlotsModal from './AvailableSlotsModal';

const SERVICE_TYPES = ['cleaning_flat_deep', 'hourly_deep_cleaning', 'cleaning_flat_renovation'];

interface IFormValues {
  addressWithRegion?: IAddressFieldProps;
}

interface IProps {
  serviceType: string;
  onSelect?: (startAt: string) => void;
}

const AvailableSlotsButton = ({ serviceType, onSelect }: IProps) => {
  const { values } = useFormState<IFormValues>({ subscription: { values: true } });
  const [isOpen, setIsOpen] = useState(false);
  const address = values.addressWithRegion?.value?.address;
  const latitude = address?.coordinates?.lat;
  const longitude = address?.coordinates?.lng;
  const canSearch = Boolean(address?.value?.trim())
    && typeof latitude === 'number' && Number.isFinite(latitude) && Math.abs(latitude) <= 90
    && typeof longitude === 'number' && Number.isFinite(longitude) && Math.abs(longitude) <= 180;

  useEffect(() => {
    setIsOpen(false);
  }, [latitude, longitude, address?.value, serviceType]);

  if (!SERVICE_TYPES.includes(serviceType)) {
    return null;
  }

  return (
    <div className="mt-2">
      <Button type="button" variant="outline-primary" size="sm" disabled={!canSearch} onClick={() => setIsOpen(true)}>
        Доступные слоты
      </Button>
      {isOpen && canSearch && (
        <AvailableSlotsModal
          latitude={latitude!}
          longitude={longitude!}
          onHide={() => setIsOpen(false)}
          onSelect={onSelect && ((startAt) => {
            onSelect(startAt);
            setIsOpen(false);
          })}
        />
      )}
    </div>
  );
};

export default AvailableSlotsButton;
